import { Injectable } from '@angular/core';
import { ChatClient } from '../../domain/models/chat-client.model';
import { ChatClientDto } from '../dtos/chat-client.dto';

@Injectable()
export class ChatClientMapper {
  public toChatClient(dto: ChatClientDto): ChatClient {
    const fullName = [dto.FirstName, dto.LastName].filter((part) => !!part?.trim()).join(' ').trim();

    return {
      id: dto.PublicId,
      username: dto.Username,
      displayName: fullName || dto.Username,
      linkedProviderClientExternalId: dto.ExternalClientId,
      departmentIds: dto.DepartmentIds ?? [],
      phone: dto.Phone ?? null,
      // Same `?? []` normalization this mapper already applies to `departmentIds`, so the
      // null-vs-empty channel is NOT informative for `petNames` either -- a row with no pets and a
      // row whose roster data never resolved look identical here. Read `rosterEnriched` for that,
      // never infer it from an empty array.
      petNames: dto.PetNames ?? [],
      rosterEnriched: dto.ProviderRosterEnriched ?? false,
    };
  }
}
